import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import NavigatorBridge from './NavigatorBridge.jsx';
import { EVENT_DATA } from '../lib/event.js';

// Admin shell: sidebar (logo + nav) + topbar (username + Salir) + content.
export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className="flex min-h-screen bg-bg font-body text-text">
      <NavigatorBridge />
      <aside className="hidden w-56 flex-col border-r border-border bg-bg md:flex">
        <div className="border-b border-border px-4 py-5 font-heading text-lg text-accent">
          {EVENT_DATA.couple.display}
        </div>
        <nav className="flex-1 px-2 py-4">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `block rounded px-3 py-2 text-sm ${
                isActive ? 'bg-accent text-white' : 'text-text hover:bg-border/40'
              }`
            }
          >
            Invitados
          </NavLink>
          <NavLink
            to="/admin/evento"
            className={({ isActive }) =>
              `block rounded px-3 py-2 text-sm ${
                isActive ? 'bg-accent text-white' : 'text-text hover:bg-border/40'
              }`
            }
          >
            Evento
          </NavLink>
        </nav>
      </aside>

      <div className="flex flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-border bg-bg px-4 py-3">
          <div className="md:hidden font-heading text-base text-accent">
            {EVENT_DATA.couple.display}
          </div>
          <div className="hidden md:block text-sm text-text-muted">Panel de administración</div>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-text-muted">{user?.username ?? ''}</span>
            <button
              type="button"
              onClick={handleLogout}
              className="rounded border border-border px-3 py-1 text-text hover:border-accent hover:text-accent"
            >
              Salir
            </button>
          </div>
        </header>

        {/* Mobile-only nav strip — the sidebar (md:flex) is hidden on phones,
            so without this strip the admin can't reach /admin/evento from a
            phone. Two pill-style NavLinks that show the active page. */}
        <nav className="flex gap-2 border-b border-border bg-bg px-4 py-2 md:hidden">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `rounded px-3 py-1 text-sm ${
                isActive ? 'bg-accent text-white' : 'text-text hover:bg-border/40'
              }`
            }
          >
            Invitados
          </NavLink>
          <NavLink
            to="/admin/evento"
            className={({ isActive }) =>
              `rounded px-3 py-1 text-sm ${
                isActive ? 'bg-accent text-white' : 'text-text hover:bg-border/40'
              }`
            }
          >
            Evento
          </NavLink>
        </nav>

        <main className="flex-1 px-4 py-6 md:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
